import { useEffect, useReducer } from 'react';
import { logger } from 'packages/logger';
import { getSimilarSellerSuggestions } from './api';
import useIsLoggedIn from 'tradera/hooks/use-is-loggedin';

const similarSellerSuggestionsReducer = (state, action) => {
    switch (action.type) {
        case 'error': {
            return {
                ...state,
                status: 'rejected',
                error: action.error
            };
        }
        case 'success': {
            return {
                ...state,
                status: 'resolved',
                suggestedSellers: action.suggestedSellers
            };
        }
        case 'started': {
            return {
                ...state,
                status: 'fetching'
            };
        }
        default: {
            throw new Error(`Unhandled action type: ${action.type}`);
        }
    }
};

const initialState = {
    suggestedSellers: [],
    status: 'idle',
    error: null
};

export const useFetchSimilarSellerSuggestions = (
    sellerMemberId,
    maxSellers,
    keepSellersWithNoItems
) => {
    const [state, dispatch] = useReducer(
        similarSellerSuggestionsReducer,
        initialState
    );
    const isLoggedIn = useIsLoggedIn();

    useEffect(() => {
        if (sellerMemberId && isLoggedIn) {
            dispatch({ type: 'started' });

            getSimilarSellerSuggestions(
                sellerMemberId,
                maxSellers,
                keepSellersWithNoItems
            )
                .then(({ data }) => {
                    dispatch({
                        type: 'success',
                        suggestedSellers: data.sellerCardDtos
                    });
                    return;
                })
                .catch((error) => {
                    dispatch({ type: 'error', error, suggestedSellers: [] });
                    logger(
                        new Error(
                            `Fetch similar seller suggestions failed ${error}`
                        )
                    );
                });
        }
    }, [sellerMemberId, maxSellers, keepSellersWithNoItems, isLoggedIn]);

    return {
        isLoading: state.status === 'idle' || state.status === 'fetching',
        ...state
    };
};
